<template>
  <div>
    <svg
      class="h-8 w-8 cursor-pointer opacity-60 transition-all duration-500 hover:opacity-90"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="transition"
        d="M11.4802 1.04024L13.7842 8.16824H21.2962C21.7762 8.16824 21.9922 8.79224 21.5842 9.08024L15.5122 13.4962L17.8402 20.6242C17.9842 21.0802 17.4562 21.4642 17.0722 21.1762L11.0002 16.7842L4.92819 21.2002C4.54419 21.4882 3.99219 21.1042 4.16019 20.6482L6.48819 13.5202L0.416192 9.10424C0.0321916 8.81624 0.224192 8.19224 0.704192 8.19224H8.21619L10.5202 1.04024C10.6642 0.584242 11.3362 0.584242 11.4802 1.04024Z"
        :fill="fill"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();

const fill = computed(() => {
  if (route.meta?.lightBg) {
    return '#999999';
  } else {
    return '#fff';
  }
});
</script>
